import { render } from "./ViewDemande.vue?vue&type=template&id=0d32f322&ts=true"
import script from "./ViewDemande.vue?vue&type=script&lang=ts"
export * from "./ViewDemande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__